import { render, staticRenderFns } from "./compareProductBom.vue?vue&type=template&id=626e371b&scoped=true&"
import script from "./compareProductBom.vue?vue&type=script&lang=js&"
export * from "./compareProductBom.vue?vue&type=script&lang=js&"
import style0 from "./compareProductBom.vue?vue&type=style&index=0&id=626e371b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626e371b",
  null
  
)

export default component.exports